<div class="login-box">
  <div class="login-logo">
    <a href="">
      <b>SmartSafe</b>CMS</a>
  </div>
  <!-- /.login-logo -->
  <div class="login-box-body">
    <p class="login-box-msg">Sign in to start your session</p>
    <div *ngIf="alert" class="alert alert-danger">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{alert}}
    </div>
    <form (ngSubmit)="onSubmit(formLogin)" #formLogin="ngForm">
      <div class="form-group has-feedback">
        <input type="email" class="form-control" name="email" ngModel #txtEmail="ngModel" placeholder="Email" required email>
        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
        <span *ngIf="txtEmail.errors?.required  && txtEmail.dirty" class="text text-danger">Email is required.
          <br>
        </span>
        <span *ngIf="txtEmail.errors?.email && txtEmail.dirty" class="text text-danger">Email is invalid.</span>
      </div>
      <div class="form-group has-feedback">
        <input type="password" class="form-control" name="password" ngModel #txtPassword="ngModel" placeholder="Password" required>
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        <span *ngIf="txtPassword.errors?.required  && txtPassword.dirty" class="text text-danger">Password is required.
          <br>
        </span>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <button [disabled]="formLogin.invalid" class="btn btn-primary btn-block btn-flat" id="btnSignIn">Sign In</button>
        </div>
        <!-- /.col -->
      </div>
    </form>
  </div>
  <!-- /.login-box-body -->
</div>
<!-- /.login-box -->


// WEBPACK FOOTER //
// /build/client-cms/src/app/login/login.component.html